import { Calendar } from '@fullcalendar/core'
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import scrollmonitor from 'scrollmonitor'
import deLocale from '@fullcalendar/core/locales/de'
import '@fullcalendar/core/main.min.css'
import '@fullcalendar/daygrid/main.min.css'
import '@fullcalendar/timegrid/main.min.css'
import '@fullcalendar/list/main.min.css'

function initGoogleMap (node) {
  const coordinates = {
    lat: parseFloat(node.dataset.lat),
    lng: parseFloat(node.dataset.lng),
  }

  const map = new window.google.maps.Map(node, {
    center: coordinates,
    zoom: 17,
  })

  /* eslint-disable-next-line no-new */
  new window.google.maps.Marker({
    position: coordinates,
    map: map,
    title: node.dataset.title,
    label: {
      text: node.dataset.title,
      color: '#333'
    },
  })
}

function watchForGoogleMap () {
  const mapNode = document.querySelector('.google-map')

  if (!mapNode) {
    return false
  }

  const mapWatcher = scrollmonitor.create(mapNode)

  mapWatcher.enterViewport(() => {
    initGoogleMap(mapNode)
    mapWatcher.destroy()
  })
}

function initCalendars () {
  document.querySelectorAll('.full-calendar').forEach(calendarNode => {
    const calendar = new Calendar(calendarNode, {
      locale: deLocale,
      plugins: [
        dayGridPlugin,
        timeGridPlugin,
        listPlugin,
      ],
      timeZone: 'UTC',
      defaultView: 'dayGridMonth',
      views: {
        dayGridMonth: {
          displayEventEnd: true,
        },
      },
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,list'
      },
      events: {
        url: `/!/IcsCalendar/events/${calendarNode.dataset.id}`,
        color: '#e0cb12',
        textColor: '#000',
        error: console.error,
      },
    })

    calendar.render()
  })
}

export default function () {
  initCalendars()
  watchForGoogleMap()
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/contentSets.js